import React, { useState } from 'react';
// export interface ISelectionDataModel {

//     layerName:string|undefined;
//     features: any[];
// 	geometryType:string;
//     //globalIdFieldName:string|undefined;
//     //objectIdFieldName:string|undefined;
//    // spatialReference:any;
//     fields:any[];
// 	popupFields:any[]
//     //fieldAliases:any;
//     //url:string

// }

// export interface ISelectDataContext {
// 	data:ISelectionDataModel[]|undefined
// }

export const OCLandInsightsContext:any = React.createContext({});
export const OCLandInsightsContextProvider = (props: { children: React.ReactNode }) => {
	const [ocLandInsightsDictionary, setOCLandinsightsDictionary] = useState({});
	return (
		<OCLandInsightsContext.Provider
			value={{
				data: ocLandInsightsDictionary,
				set: (e) => {
					setOCLandinsightsDictionary(e);
				},
				setOCLandinsightsDictionary:setOCLandinsightsDictionary
			}}
		>
			{props.children}
		</OCLandInsightsContext.Provider>
	);

};